export default __webpack_public_path__ + "static/media/raise3.6b2eba0c.mp3";